import React, { Component } from "react";
import { Link } from 'react-router-dom';
const Portfolio_image = <img src="/assets/images/portfolio/Inveve-Coding_Image_1_390x532.png" alt="React Creative Agency" />;
const Portfolio_image2 = <img src="/assets/images/portfolio/Inveve-Coding_Image_2_390x532.png" alt="React Creative Agency" />;
const Portfolio_image3 = <img src="/assets/images/portfolio/Inveve-Coding_Image_3_390x532.png" alt="React Creative Agency" />;

const PortfolioList = [
    {
        image: Portfolio_image,
        category: 'Data Driven',
        title: 'Strategize',
        description: 'We strategize based on real data and consumer feedback.'
    },
    {
        image: Portfolio_image2,
        category: 'Development',
        title: 'Build',
        description: 'We design a full stack solution to fit your needs and budget'
    },
    {
        image: Portfolio_image3,
        category: 'Machine Learning',
        title: 'Automate',
        description: 'We automate your processes to streamline and drive efficiency.'
    }
]

class Portfolio extends Component{
    render(){
        let title = 'Learn. Design. Implement.',
        description = 'All input is error';
        return(
            <React.Fragment>
                <div className="portfolio-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <span className="subtitle">Our project</span>
                                    <h2 className="title">{title}</h2>
                                    <p className="description" dangerouslySetInnerHTML={{ __html: description }}></p>
                                </div>
                            </div>
                        </div>
                        <div className="row mt--30">
                            {PortfolioList.map((value , index) => (
                                <div className="col-lg-4 col-md-6 col-sm-6 col-12 mt--30" key={index}>
                                    <div className="im_portfolio">
                                        <div className="thumbnail_inner">
                                            <div className="thumbnail">
                                                <Link to="/portfolio-details">
                                                    {value.image}
                                                </Link>    
                                            </div>
                                        </div>
                                        <div className="content">
                                            <div className="inner">
                                                <div className="portfolio_heading">
                                                    <div className="category_list">
                                                        <Link to="/portfolio-details">{value.category}</Link>
                                                    </div>
                                                    <h4 className="title"><Link to="/portfolio-details">{value.title}</Link></h4>
                                                </div>
                                                <div className="portfolio_hover">
                                                    <p>{value.description}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <Link className="transparent_link" to="/portfolio-details"></Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    
                </div>
            </React.Fragment>
        )
    }
}
export default Portfolio;